import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import { api } from "@/lib/api";

export default function ServicesIndex() {
  const [pages, setPages] = useState([]);
  useEffect(() => {
    api.get("/services-index").then((r) => setPages(r.data.pages)).catch(() => {});
  }, []);
  const groups = [...new Set(pages.map((p) => p.group))];
  return (
    <>
      <Seo
        title="All Services — Solar, Storage, Roofing, EV, HVAC | Solar Black Belt"
        description="Every Coastal Energy service on one page: residential and commercial solar, Tesla Powerwall, Generac, Solar Roof service, roofing, EV charging, SPAN, HVAC, insulation, service plans, warranty and financing — with published planning prices."
      />
      <section className="page-hero">
        <div className="wrap">
          <span className="eyebrow">ALL SERVICES</span>
          <h1 data-testid="services-index-heading">Every service. Every price. One page.</h1>
          <p className="lead">
            Solar and storage, roofing and construction, EV and electrical, comfort and efficiency, protection and planning —
            installed by licensed Florida crews. Published planning prices are shown with their qualifiers on each page.
          </p>
        </div>
      </section>
      <section className="section" style={{ paddingTop: 40 }}>
        <div className="wrap">
          {groups.map((g) => (
            <div key={g} style={{ marginBottom: 30 }}>
              <span className="eyebrow">{g.toUpperCase()}</span>
              <div className="blog-grid" data-testid={`services-group-${g.replace(/[^a-z]/gi, "-").toLowerCase()}`}>
                {pages.filter((p) => p.group === g).map((p) => (
                  <Reveal key={p.id}>
                    <article className="blog-card" data-testid={`services-index-${p.id}`}>
                      <h3><Link to={p.route}>{p.name}</Link></h3>
                      <span className="report-tag">{p.pricingRows?.[0]?.amount || "Request quote"}</span>
                      <p>{(p.hero || "").slice(0, 120)}…</p>
                      <Link className="micro" to={p.route} style={{ fontWeight: 800, color: "var(--teal)" }}>See pricing &amp; FAQs →</Link>
                    </article>
                  </Reveal>
                ))}
              </div>
            </div>
          ))}
          <p className="micro">
            Looking for Indoor Air Quality? It lives on the <Link to="/services/hvac#indoor-air-quality">HVAC &amp; Indoor Air Quality</Link> page.
            Hiring? All solar positions are open on the <Link to="/careers">Careers</Link> page.
          </p>
        </div>
      </section>
    </>
  );
}
